import * as React from 'react';
const styles = require('./index.css');

import { IPhoneSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Button, ButtonSize } from '@cian/button-component';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { ComplaintButtonContainer } from '../../main/complaint_button/container';
import { CalltrackingBadgeContainer } from '../../../containers/CalltrackingBadge';
import { CallSourceWishContainer } from '../../../containers/CallSourceWish';

export interface IBargainTermsPhonesProps extends React.HTMLProps<HTMLDivElement> {
  phones: IPhoneSchema[];
}

export interface IBargainTermsPhonesState {
  isPhonesOpened: boolean;
}

export class BargainTermsPhones extends React.PureComponent<IBargainTermsPhonesProps, IBargainTermsPhonesState> {
  public state: Readonly<IBargainTermsPhonesState> = {
    isPhonesOpened: false,
  };

  public render() {
    const { phones, className, ...restProps } = this.props;
    const { isPhonesOpened } = this.state;
    const phonesAvailable = phones && !phones.some(phone => !phone.countryCode || !phone.number);

    if (!phonesAvailable) {
      return null;
    }
    const style = mergeStyles(className, styles['phone_container'], isPhonesOpened && styles['phone_container_opened']);

    return (
      <div {...restProps} {...style}>
        {isPhonesOpened ? (
          this.renderPhones(phones)
        ) : (
          <Button
            onClick={() => this.setState({ isPhonesOpened: true })}
            size={ButtonSize.S}
            className={styles['button']}
          >
            Уточнить условия
          </Button>
        )}
        <ComplaintButtonContainer className={'bargain ' + styles['complaint_info']} />
      </div>
    );
  }

  private renderPhones = (phones: IPhoneSchema[] | null) => {
    if (!phones) {
      return null;
    }

    return (
      <div className={styles['phone_info']}>
        {(phones as IPhoneSchema[])
          .map(phone => {
            return (
              phone.number &&
              `${phone.countryCode} ${phone.number.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2-$3-$4')}`
            );
          })
          .filter(Boolean)
          .join(', ')}
        <CalltrackingBadgeContainer />
        <div className={styles['sign']}>
          <CallSourceWishContainer />
        </div>
      </div>
    );
  };
}
